import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Row, Col, Input, Form } from 'reactstrap';
import { AccountType, EmailAddress, EmailsPlaceHolder, FirstName, Gender, LastName } from '../../../utils/Constant';
import { updateUserByAdminAction } from '../../../Api/auth';
import { toast } from 'react-toastify';
import { useAppSelector } from '../../../ReduxToolkit/Hooks';

interface EditUserModalProps {
  modal: boolean
  setModal: (isModal: boolean) => void;
  patient: any
  patients: any
  setPatients: (users: any) => void;
}

const EditUserModal: React.FC<EditUserModalProps> = ({ modal, setModal, patient, patients, setPatients }) => {
  const [firstname, setFirstName] = useState(patient?.firstname);
  const [lastname, setLastName] = useState(patient?.lastname);
  const [parentFirstName, setParentFirstName] = useState(patient?.parent_firstname)
  const [parentLastName, setParentLastName] = useState(patient?.parent_lastname)
  const [email, setEmail] = useState(patient?.email);
  const [phonenumber, setPhoneNumber] = useState(patient?.phonenumber);
  const [address, setAddress] = useState(patient?.address)
  const [gender, setGender] = useState(patient?.gender)
  const [school, setSchool] = useState(patient?.school)
  const [teacherEmail, setTeacherEmail] = useState(patient?.teacher_email)
  const [gpEmail, setGpEmail] = useState(patient?.gp_email)
  const [treatingClinicEmail, setTratingClinicEmail] = useState(patient?.treating_clinic_email)
  const [role, setRole] = useState(patient?.role);
  const userSelf = useAppSelector(state => state.user)
  const toggle = () => setModal(!modal);

  useEffect(() => {
    setFirstName(patient?.firstname)
    setLastName(patient?.lastname)
    setEmail(patient?.email)
    setPhoneNumber(patient?.phonenumber)
    setAddress(patient?.address)
    setGender(patient?.gender)
    setRole(patient?.role)
    setSchool(patient?.school)
    setTeacherEmail(patient?.teacher_email)
    setGpEmail(patient?.gp_email)
    setParentFirstName(patient?.parent_firstname)
    setParentLastName(patient?.parent_lastname)
    setTratingClinicEmail(patient?.treating_clinic_email)
  }, [patient])

  const updateUserHandle = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const _user = {
      firstname,
      lastname,
      email,
      gender,
      phonenumber,
      address,
      gp_email: gpEmail,
      treating_clinic_email: treatingClinicEmail,
      teacher_email: teacherEmail,
      school,
      parent_firstname: parentFirstName,
      parent_lastname: parentLastName
    }
    const response = await updateUserByAdminAction(_user)
    if (response.data && response.data.status === "success") {
      toast.success("Updated User Successfully!");
      const _users = patients.map((u: any) => {
        if (u.id === response.data.payload.updated_patient.id) {
          return response.data.payload.updated_patient
        }
        return u
      })
      setPatients(_users)
      toggle()
    }

    else {
      const _response: any = response
      if (_response?.response)
        toast.error(_response.response.data.message)
      else
        toast.error("Update failed!")
    }
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Edit Patient</ModalHeader>
        <Form className="theme-form" onSubmit={(event: any) => updateUserHandle(event)}>
          <ModalBody>
            <div>
              <Label className="col-form-label pt-0">{"Patient Name"}</Label>
              <Row className="g-2">
                <Col xs="6">
                  <Input type="text" required value={firstname} placeholder={FirstName} onChange={(event) => setFirstName(event.target.value)} />
                </Col>
                <Col xs="6">
                  <Input type="text" required value={lastname} placeholder={LastName} onChange={(event) => setLastName(event.target.value)} />
                </Col>
              </Row>
            </div>
            {
              patient.type === "child" &&
              <div className='mt-2'>
                <Label className="col-form-label pt-0">{"Parent Name"}</Label>
                <Row className="g-2">
                  <Col xs="6">
                    <Input type="text" required value={parentFirstName} placeholder={FirstName} onChange={(event) => setParentFirstName(event.target.value)} />
                  </Col>
                  <Col xs="6">
                    <Input type="text" required value={parentLastName} placeholder={LastName} onChange={(event) => setParentLastName(event.target.value)} />
                  </Col>
                </Row>
              </div>
            }
            <div>
              <Label className="col-form-label ">{Gender}</Label>
              <div className="form-check-size rtl-input">
                <div className="form-check form-check-inline">
                  <Input className="border me-2" id="gender_male" type="radio" name="gender_male" value="male" checked={gender === "male"} onChange={(e) => setGender(e.target.value)} />
                  <Label for='gender_male' style={{ cursor: "pointer" }} check>Male</Label>
                </div>
                <div className="form-check form-check-inline">
                  <Input className="border me-2" id="gender_female" type="radio" name="gender_female" value="female" checked={gender === "female"} onChange={(e) => setGender(e.target.value)} />
                  <Label for='gender_female' style={{ cursor: "pointer" }} check>Female</Label>
                </div>
                <div className="form-check form-check-inline">
                  <Input className="border me-2" id="gender_prefer_not_say" type="radio" name="gender_prefer_not_say" value="" checked={!gender} onChange={(e) => setGender(e.target.value)} />
                  <Label for='gender_prefer_not_say' style={{ cursor: "pointer" }} check>Prefer not to say</Label>
                </div>
              </div>
            </div>

            <div>
              <Label className="col-form-label">{EmailAddress}</Label>
              <Input type="email" required placeholder={EmailsPlaceHolder} value={email} onChange={(event) => setEmail(event.target.value)} />
            </div>
            <div>
              <Label className="col-form-label">{"Phone Number"}</Label>
              <Input type="text" placeholder={"Phone Number"} required value={phonenumber} onChange={(event) => setPhoneNumber(event.target.value)} />
            </div>
            <div>
              <Label className="col-form-label">{"Address"}</Label>
              <Input type="text" placeholder={"Address"} required value={address} onChange={(event) => setAddress(event.target.value)} />
            </div>
            {
              patient.type === "child" && <div>
                <Label className="col-form-label">{"School"}</Label>
                <Input type="text" placeholder={"School"} required value={school} onChange={(event) => setSchool(event.target.value)} />
              </div>
            }
            {
              patient.type === "child" && <div>
                <Label className="col-form-label">{"Teacher Email (optional)"}</Label>
                <Input type="text" placeholder={"Teacher Email"} value={teacherEmail} onChange={(event) => setTeacherEmail(event.target.value)} />
              </div>
            }
            {
              patient.type === "child" && <div>
                <Label className="col-form-label">{"GP Email (optional)"}</Label>
                <Input type="text" placeholder={"GP Email"} value={gpEmail} onChange={(event) => setGpEmail(event.target.value)} />
              </div>
            }
            {
              patient.type === "child" && <div>
                <Label className="col-form-label">{"Treating Clinic Email (optional)"}</Label>
                <Input type="text" placeholder={"Treating Clinic Email"} value={treatingClinicEmail} onChange={(event) => setTratingClinicEmail(event.target.value)} />
              </div>
            }
            {userSelf.role === "admin" &&
              <FormGroup>
                <Label className="col-form-label">{AccountType}</Label>
                <Input type="select" required placeholder={""} value={role} onChange={(event) => { setRole(event.target.value) }}>
                  <option value={"admin"}>ADMIN</option>
                  <option value={"clinician"}>CLINICIAN</option>
                </Input>
              </FormGroup>
            }
          </ModalBody>
          <ModalFooter>
            <Button color="primary">
              Save
            </Button>{' '}
            <Button color="danger" onClick={() => {
              setFirstName(patient.firstname)
              setLastName(patient.lastname)
              setEmail(patient.email)
              setPhoneNumber(patient.phonenumber)
              toggle()
            }}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>

      </Modal>
    </div>
  );
}

export default EditUserModal;